import { StyleRules, MenuItemClassKey } from '@material-ui/core';

export const MuiMenuItem: Partial<StyleRules<MenuItemClassKey, {}>> = {
  gutters: {
    paddingLeft: 12,
    paddingRight: 12,
  },
};
